<template>
    <div class="drag-sort" :class="className" ref="drag">
        <slot></slot>
    </div>
</template>

<script>
import Sortable from '@/assets/js/sortable';
export default {
    name: 'drag-sort',
    props: {
        value: Array,
        animation: {
            type: [Number, String],
            default: 200
        },
        sort: {
            type: Boolean,
            default: true
        },
        group: {
            type: [String, Object],
            default: ''
        },
        className: {
            type: String,
            default: ''
        },
        draggable: {
            type: String,
            default: '.item'
        },
        handle: {
            type: String,
            default: ''
        },
        direction: String,
        fallbackOnBody: Boolean,
        disabled: Boolean
    },
    components: {

    },
    data() {
        return {

        }
    },
    computed: {

    },
    created() {

    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            new Sortable(this.$refs.drag, {
                animation: this.animation,
                sort: this.sort,
                group: this.group,
                draggable: this.draggable,
                handle: this.handle,
                direction: this.direction,
                fallbackOnBody: this.fallbackOnBody,
                disabled: this.disabled,
                filter: '.van-uploader__preview-delete',
                delay: 100,
                delayOnTouchOnly: true,
                preventOnFilter: false,
                onAdd: (event) => {
                    this.removeNode(event.item);
                    this.$emit('add', event);
                },
                onEnd: (event) => {
                    if (this.value) {
                        this.value.splice(event.newIndex, 0, this.value.splice(event.oldIndex, 1)[0]);
                        var newArray = this.value.splice(0);
                        this.$nextTick(() => {
                            this.$emit('input', newArray);
                        });
                    }
                    this.$emit('end', event);
                },
                onStart: (event) => {
                    this.$emit('start', event);
                },
                onChoose: (event) => {
                    this.$emit('choose', event);
                },
                onUpdate: (event) => {
                    this.$emit('update', event);
                },
                onSort: (event) => {
                    this.$emit('sort', event);
                },
                onRemove: (event) => {
                    this.$emit('remove', event);
                },
                onFilter: (event) => {
                    this.$emit('filter', event);
                },
                onMove: (event) => {
                    this.$emit('move', event);
                },
                onClone: (event) => {
                    this.$emit('clone', event);
                },
                onChange: (event) => {
                    this.$emit('change', event);
                },
                setData: (transfer, event) => {
                    transfer.setData('Text', '');
                    this.$emit('setData', { transfer, event });
                }
            });
        },
        removeNode(node) { //删除元素
            if (node.parentElement !== null) {
                node.parentElement.removeChild(node);
            }
        }
    },
    watch: {

    }
}
</script>